const permissions = {
  admin: ['HOLDINGS:APPROVE'],
}

module.exports = {
  permissions,
  can: (user, permission) => {
    if (!user || !user.roles) return false
    let canDo = false
    user.roles.forEach((role) => {
      if (
        permissions[role.title] &&
        permissions[role.title].includes(permission)
      )
        canDo = true
    })
    return canDo
  },
}
